var __jsx = React.createElement;
import React from 'react';

// Styles
import 'styles/layout/footers/footer.css';
import 'styles/layout/footers/footer-explore.css';
import MobileFooter from './templates/mobile';
import WebFooter from './templates/web';
import useMuscleRouter from '@lib/hooks/use-muscle-router';
import { cn } from '@lib/cn';
import useCssModules from '@lib/hooks/use-css-modules';
import { BREAKPOINTS } from '@lib/constants';
import { useMediaQuery } from 'react-responsive';
const FooterBancogral = () => {
  var _cssModules$footers$f;
  const router = useMuscleRouter();
  const {
    cssModules
  } = useCssModules();
  const {
    containerClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerBancogral) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  return __jsx("div", {
    className: cn("".concat(containerClassNames), !router.isHome() && !router.isLanding() && 'pt-[20px]')
  }, isMobile ? __jsx(MobileFooter, null) : __jsx(WebFooter, null));
};
export default FooterBancogral;